var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 320,
    viewBox: "0 0 640 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4131 125.302C92.4131 136.313 94.635 149.492 111.608 149.492C124.922 149.492 153.123 149.492 153.123 149.492V119.994H120.612V132.193H140.586V137.889C140.586 137.889 120.023 137.889 114.342 137.889C104.489 137.889 105.925 128.318 105.925 125.503C105.925 118.491 107.229 114.686 113.757 114.686H153.121V102.002H113.954C98.4877 102.002 92.4131 111.145 92.4131 125.302Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.915 149.492H217.785V137.886H178.133V132.19H217.785V120.683H178.133V115.667H217.785V102.002H164.915V149.492Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.218 137.001L247.589 102.002H229.57V149.492H241.907V114.485L268.537 149.492H286.556V102.002H274.218V137.001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.917 149.492H352.787V137.886H313.135V132.19H352.787V120.683H313.135V115.667H352.787V102.002H299.917V149.492Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.72 118.912C423.72 112.322 423.589 102 407.86 102H364.582V149.492H377.312V135.627H397.088L408.155 149.492H424.603L412.756 134.25C421.433 132.961 423.72 126.788 423.72 118.912ZM404.234 124.004H377.303V115.056H404.427C408.052 115.056 410.596 116.136 410.596 119.09C410.596 122.037 410.007 124.004 404.234 124.004Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.533 102.002H501.318V149.492H548.9V137.886H514.533V102.002Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.537 102.002L425.907 149.494H440.399L445.624 140.151H476.623L481.813 149.494H496.305L469.671 102.002H452.537ZM452.167 128.431L461.104 112.455L470.064 128.431H452.167Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.161 171.447H70V184.13V218.939C70 218.939 98.1992 218.939 111.515 218.939C127.442 218.939 130.702 208.905 130.702 194.748C130.702 180.592 124.631 171.447 109.161 171.447ZM108.768 207.332C103.086 207.332 82.5272 207.332 82.5272 207.332V184.128H109.355C116.667 184.128 117.187 188.722 117.187 194.946C117.189 200.646 117.319 207.332 108.768 207.332Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.708 206.446L218.078 171.447H200.06V218.937H212.401V183.931L239.031 218.937H257.047V171.447H244.708V206.446Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.412 171.447L262.778 218.939H277.27L282.495 209.597H313.497L318.684 218.939H333.175L306.54 171.447H289.412ZM289.036 197.876L297.973 181.9L306.933 197.876H289.036Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.892 191.896L145.984 171.447H128.749L155.971 202.521V218.937H169.485V202.521L196.702 171.447H179.468L162.892 191.896Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.096 204.529L358.432 171.447H338.068V218.937H350.406V182.703L368.418 218.937H379.777L397.796 182.703V218.937H410.125V171.447H389.764L374.096 204.529Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.395 171.447V218.937H437.714L437.617 171.447H424.395Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.003 194.746C447.003 208.903 450.263 218.937 466.198 218.937C479.512 218.937 503.594 218.937 503.594 218.937V207.383C503.594 207.383 474.612 207.332 468.934 207.332C460.386 207.332 460.517 200.646 460.517 194.946C460.517 188.718 461.037 184.128 468.345 184.128H503.594V171.447H468.543C453.074 171.447 447.003 180.59 447.003 194.746Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.003 190.03H527.41C525.357 190.03 523.053 189.44 523.053 187.179C523.053 184.918 525.357 184.328 527.41 184.328C533.092 184.328 568.434 184.28 568.434 184.28V172.727C568.434 172.727 537.597 172.727 524.273 172.727C513.02 172.727 510.28 178.528 510.28 187.179C510.28 195.83 513.02 201.635 524.273 201.635H552.866C554.926 201.635 557.223 202.217 557.223 204.486C557.223 206.749 554.926 207.33 552.866 207.33C547.192 207.33 511.842 207.381 511.842 207.381V218.935C511.842 218.935 542.687 218.935 556.003 218.935C567.26 218.935 570 213.131 570 204.486C570 195.832 567.26 190.03 556.003 190.03Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.a4e8006a7a0e383e5d23c3c339b14693.svg";
export { ForwardRef as ReactComponent };